import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	PAGE_REACTIONS_SEGMENT_KEY,
	FEED_REACTIONS_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const PAGE_REACTIONS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: PAGE_REACTIONS_SEGMENT_KEY,
});

export const FEED_REACTIONS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: FEED_REACTIONS_SEGMENT_KEY,
});
